// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"662cafa3","774":"e509ab81","854":"b97f8bd9"}[chunkId] + ".chunk.js";
};